import { TotalVolResponse, TotalVolData } from './../../models/Coin';
import { Platform } from 'ionic-angular';
import { AngularFireDatabase } from 'angularfire2/database';
import { TopExchange, TopExchangeResponse } from './../../models/Exchanges';
import { PriceMap } from './../../models/PriceMap';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CMC } from '../../models/CoinMarketCap';
import { Coin, PriceFullRaw, CoinSnapshot} from '../../models/Coin';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/shareReplay';

import { Exchanges, AllExchangesResponse } from '../../models/Exchanges';
import { ToastService } from '../util/toast.service';

/*
  Generated class for the CoinsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CoinsProvider {

  private allCoins: CMC.AllCoins;
  allCoinsO: Observable<CMC.AllCoins>;
  exchanges: Observable<Exchanges>;
  currency: string = "USD";
  priceMap: PriceMap;
  SATOSHI_MULTIPLIER: number = 100000000;

  bigMap: PriceMap;

  constructor(public http: HttpClient, private db: AngularFireDatabase, private platform: Platform, private toast: ToastService) {
    this.allCoinsO = this.getAllCoinsO().shareReplay(1);
    this.allCoinsO.subscribe(data => {

    });
    this.priceMap = new PriceMap(http);

    this.exchanges = this.getExchanges();

    //Refresh on load
    this.platform.resume.subscribe(() => {
      this.refreshMap();
    })

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        this.refreshMap();
      }
    }, false);

  }

  getExchangeFeeds(){
    return this.http.get('https://min-api.cryptocompare.com/data/all/cccaggexchanges')
  }

  getAllCoinsO(): Observable<CMC.AllCoins>{
    let url = "https://min-api.cryptocompare.com/data/all/coinlist"
    return this.http.get(url)
      .map((response: CMC.AllCoinsResponse) => {
        return response.Data;
      });
  }

  public getAllCoins(): Observable<CMC.AllCoins>{
    return this.allCoinsO;
  }

  public getCoinByName(name: string): Observable<Coin>{
    name = name.replace('$', '');
    return this.getAllCoins()
      .map(allCoins => {
        let count = 0;
        for(let c in allCoins) count++;
        if(allCoins){
          return allCoins[name];
        }else{
          return null;
        }
      }).first();
  }

  public getCoinsByName(names: string[]): Observable<Coin[]>{
    return this.getAllCoins()
      .map(allCoins => {
        let coins = [];
        if(allCoins){
          for(let name of names){
            if(!allCoins[name]){
            }else{
              coins.push(allCoins[name]);
            }
          }
        }
        return coins;
      }, error => console.log(error)).first();
  }

  public getCoinSnapshot(coin: Coin): Observable<CoinSnapshot>{
    const path = `coin/${coin.Id}/General`
    return this.db.object<CoinSnapshot>(path).valueChanges().first();
  }

  public getCoinImageUrl(coin: Coin): string{
    if(coin) return `https://www.cryptocompare.com/${coin.ImageUrl}`;
    else return `/assets/imgs/logo.png`
  }
  //PriceMap Operations
  getPrice(coin: Coin): PriceFullRaw{
    return this.priceMap.getPrice(coin);
  }

  addCoinsToMap(coins: Coin[]){
    this.priceMap.addCoins(coins);
  }

  removeCoinsFromMap(coins: Coin[]){
    this.priceMap.removeCoins(coins);
  }

  refreshMap(){
    this.priceMap.refresh();
  }

  getPriceSimple(coin: string, currency: string): Observable<number>{

    const url = `https://min-api.cryptocompare.com/data/price?fsym=${coin}&tsyms=${currency}`;

    return this.http.get(url).map(response => {
      return response[currency];
    });
  }

  getCoinsByVolume(limit: number, page: number): Observable<TotalVolData[]>{
    let currency = (this.getCurrency() == 'Satoshi' ? 'BTC' : this.getCurrency());
    const url = `https://min-api.cryptocompare.com/data/top/totalvol?tsym=${currency}&limit=${limit}&page=${page}`
    return this.http.get(url)
      .map((response: TotalVolResponse) => response.Data);
  }

  getGlobalStats(): Observable<CMC.Global>{
    let currency = (this.getCurrency() == 'Satoshi' ? 'BTC' : this.getCurrency());
    let url = 'https://api.coinmarketcap.com/v1/global/';
    if(currency != 'USD') url += `?convert=${currency}`;
    return this.http.get(url)
      .map((global: CMC.Global) => {
        return global;
      });
  }

  getDynamicChart(coin: Coin, interval: string): Observable<any>{
    let limit: number;
    let url: string;
    let currency = (this.getCurrency() == 'Satoshi' ? 'BTC' : this.getCurrency());

    switch(interval){
      case 'day':
        limit = 24; //60 minutes * 24 hours
        url = `https://min-api.cryptocompare.com/data/histohour?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`;
        break;
        // limit = 1440; //60 minutes * 24 hours
        // url = `https://min-api.cryptocompare.com/data/histominute?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`;
        // break;
      case 'week':
        limit = 168; //60 minutes * 24 hours * 7 days
        url = `https://min-api.cryptocompare.com/data/histohour?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`;
        break;
      case 'month':
        limit = 30; //30 days 'average' - should use a lib to count how many days in month?
        url = `https://min-api.cryptocompare.com/data/histoday?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`;
        break;
      case '3month':
        limit = 90; //30 days * 3
        url = `https://min-api.cryptocompare.com/data/histoday?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`;
        break;
      case 'year':
        limit = 365; //365 days
        url = `https://min-api.cryptocompare.com/data/histoday?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`;
        break;
    }
    return this.http.get(url)
      .map((response: CMC.HistoResponse) => {
        if(response.Response == 'Error') this.toast.presentErrorToast();
        let data = response.Data;
        if(this.getCurrency() == 'Satoshi') data = this.convertOHLVCtoSatoshis(data);
        return this.getSimpleData(data);
      }, error => {
        this.toast.presentErrorToast();
      })
  }

  private getSimpleData(data: CMC.OHLVC[]){
    let chartData = [];

    for(let i of data){
      let time = new Date(i.time * 1000).toLocaleString();
      chartData.push({
        "name": time,
        "value": i.close
      });
    }

    return chartData;
  }

  getChartData(interval: string, coin: Coin, startDate: string): Observable<CMC.OHLVC[]>{
    let url;
    let limit;
    let currency = (this.getCurrency() == 'Satoshi' ? 'BTC' : this.getCurrency());

    if(interval == 'day'){
      //API max changed to 2000
      limit = 2000;
      url = `https://min-api.cryptocompare.com/data/histoday?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`
    }else if(interval == 'hour'){
      limit = 1440; //2 MONTHS
      url = `https://min-api.cryptocompare.com/data/histohour?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`
    }else{
      limit = 1440; //1 Day
      url = `https://min-api.cryptocompare.com/data/histominute?fsym=${coin.Name}&tsym=${currency}&limit=${limit}`
    }

    return this.http.get(url)
      .map((response: CMC.HistoResponse) => {
        let data = response.Data;

        if(this.getCurrency() == 'Satoshi') data = this.convertOHLVCtoSatoshis(data);
        return data;
      }, error =>{

      })
  }

  private convertOHLVCtoSatoshis(data: CMC.OHLVC[]): CMC.OHLVC[]{
    const multi = this.SATOSHI_MULTIPLIER
    for(let point of data){
      point.close *= multi;
      point.high *= multi;
      point.low *= multi;
      point.open *= multi;
      //One of these is probably wrong. Volume from is base currency.
      point.volumefrom *= multi;
      point.volumeto *= multi;
    }
    return data;
  }

  //Currency operations
  setCurrency(currency: string, loader: any): void{
    this.priceMap.setCurrency(currency, loader);
  }

  getCurrency(): string{
    return this.priceMap.currency;
  }

  public getCurrentCurrencySymbol(){
    return this.getCurrencySymbol(this.priceMap.currency);
  }

  public getCurrencySymbol(currency: string): string{
    const map = {
      'BTC': 'Ƀ',
      'Satoshi': 'sat ',
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'JPY': '¥',
      'ETH': 'Ξ'
    }

    if(map[currency]){
      return map[currency];
    }else{
      return currency;
    }
  }


  //Exchange operations
  public getExchanges(): Observable<Exchanges>{
    let url = `https://min-api.cryptocompare.com/data/all/exchanges`
    return this.http.get(url)
      .map((response: AllExchangesResponse) => {
        let e = new Exchanges(response);
        return e;
      })
  }

  /**
   * Gets TopExchanges for use in markets component
   * @param coin of the page - used as base
   * @param currency from the selector - used as quote
   */
  public getTopExchanges(coin: Coin): Observable<TopExchange[]>{
    let currency = (this.getCurrency() == 'Satoshi' ? 'BTC' : this.getCurrency());

    let url = `https://min-api.cryptocompare.com/data/top/exchanges/full?fsym=${coin.Name}&tsym=${currency}&limit=100`;
    return this.http.get(url)
      .map((response: TopExchangeResponse) => {
        let exchanges: TopExchange[] = [];
        if(response.Data.Exchanges){
          for(let e of response.Data.Exchanges){
            exchanges.push(new TopExchange([e]));
          }
        }
        return exchanges;
      })
  }
}



// WEBPACK FOOTER //
// ./src/providers/coins/coins.ts